import { useEffect } from "react";
import { FILTER_KEY, PAGE_SIZE, SEARCHSTRING } from "../config";
import { Filter } from "../components/helpers/filterBuilder/FilterBuilder";
import { TableInfo } from "../api";

export const useHandleFilterFromStorage = (
  table: TableInfo,
  temporaryFilters?: boolean | null
) => {
  useEffect(() => {
    const filterFromStorage = window.localStorage.getItem(FILTER_KEY);
    if (filterFromStorage && table.data && !temporaryFilters) {
      // if (filterFromStorage && table.data) {
      const filterItemArr = filterFromStorage.split(" | ");
      const filters: Filter[] = filterItemArr.map(filt => {
        const [columnKey, operator, ...rest] = filt.split(" ");
        const valueStrInBrackets = rest.join(" ");
        const value = valueStrInBrackets.substring(
          valueStrInBrackets.indexOf("(") + 1,
          valueStrInBrackets.indexOf(")")
        );

        return { columnKey, operator, value: value };
      });

      table.data?.actions.setFilters(filters);
      window.localStorage.removeItem(FILTER_KEY);
    }

    const searchhstringFromStorage = window.localStorage.getItem(SEARCHSTRING);
    if (searchhstringFromStorage && table.data) {
      table.data?.actions.changeSearch(searchhstringFromStorage);
      window.localStorage.removeItem(SEARCHSTRING);
    }

    const pageSizeFromStorage = window.localStorage.getItem(PAGE_SIZE);
    if (pageSizeFromStorage && table.data) {
      table.data?.actions.changePageSize(parseInt(pageSizeFromStorage));
      window.localStorage.removeItem(PAGE_SIZE);
    }
  }, [table.data, temporaryFilters]);
  // }, [table.data]);
};
